<template>
    <div class="header-nav-wrapper">
    <ul class="header-nav clearfix">
        <li>
            <router-link to="/main"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('main')>=0}
                ]">
                首页
            </router-link>
        </li>
        <li>
            <router-link to="/photograph"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('photograph')>=0}
                ]">
                影像服务
            </router-link>
        </li>
        <li>
            <router-link to="/lensman"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('lensman')>=0 && $route.path.indexOf('center')<0}
                ]">
                摄影师
            </router-link>
        </li>
        <li>
            <router-link to="/dresser"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('dresser')>=0 && $route.path.indexOf('center')<0}
                ]">
                化妆师
            </router-link>
        </li>
        <li>
            <router-link to="/field"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('field')>=0}
                ]">
                空间共享
            </router-link>
        </li>
        <li>
            <router-link to="/clothes"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('clothes')>=0}
                ]">
                租赁共享
            </router-link>
        </li>
        <!-- 影像课堂入口暂时隐藏
        <li>
            <router-link to="/video"
                :class="[
                    'header-nav-item',
                    {'nav-active': $route.path.indexOf('video')>=0}
                ]">
                影像课堂
            </router-link>
        </li>
        -->
        <li>
            <router-link to="/metope"
                :class="[
                    'header-nav-item',
                    {
                        'nav-active': $route.path.indexOf('metope')>=0 || $route.path.indexOf('media')>=0
                    }
                ]">
                制作商城
            </router-link>
        </li>
        <li>
            <button
                type="button"
                :class="[
                    'header-nav-item',
                    'header-nav-item--creator',
                    {'nav-active': $route.path.indexOf('creator') >= 0}
                ]"
                @click="openCreatorCenter">
                <img
                    class="header-nav-creator-image"
                    src="@/assets/images/creator-center-entry.png"
                    alt="创作者中心">
            </button>
        </li>
        <!-- <li>
            <router-link to="/equipment"
                :class="[
                    'header-nav-item',
                    {
                        'nav-active': $route.path.indexOf('equipment')>=0 || $route.path.indexOf('cosmetics')>=0
                    }
                ]">
                影像商城
            </router-link>
        </li> -->
    </ul>
    </div>
</template>

<script>
export default {
    methods: {
        openCreatorCenter() {
            const { href } = this.$router.resolve({ name: 'creatorCenter' });
            window.open(href, '_blank', 'noopener');
        },
    },
}
</script>

<style scoped>
/* 组件容器 */
.header-nav{
    display: flex;
    justify-content: space-between;
}
.header-nav>li{
    flex: 1;
}
.header-nav-item{
    display: block;
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-weight: blod;
    color: #303133;
    transition: all .2s linear;
    border-radius: 2px;
    border: 0;
    background: transparent;
    cursor: pointer;
}
.header-nav-item--creator{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}
.header-nav-creator-image{
    display: block;
    width: 100%;
    height: auto;
    max-width: none;
    transform: translateY(-5px);
}
.header-nav-item:hover{
    background: #8d9afc;
    color: #fff;
}
.nav-active{
    background: #8d9afc;
    color: #fff;
}
</style>
